import { render, staticRenderFns } from "./upFile.vue?vue&type=template&id=03aaf9da&scoped=true"
import script from "./upFile.vue?vue&type=script&lang=js"
export * from "./upFile.vue?vue&type=script&lang=js"
import style0 from "./upFile.vue?vue&type=style&index=0&id=03aaf9da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03aaf9da",
  null
  
)

export default component.exports